module.exports = __webpack_public_path__ + "img/pricerium_logo.da4e0e0f.png";